import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { wrapDisplayName } from 'recompose';
import { position } from 'polished';
import { withClient } from '@deerplusofficial/pos-hoc';
import { Topbar, Drawer } from '../components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  ${position('absolute', '0', null, null, '0')};
`;

const Main = styled.div`
  flex-grow: 1;
  position: relative;
`;

export default (config = { search: true }) => Component =>
  withClient()(
    class extends React.Component {
      static displayName = wrapDisplayName(Component, 'WithTopbar');

      componentDidMount() {
        const {
          history,
          pathTo,
          client: { posId },
        } = this.props;

        if (_.size(posId)) return;

        history.push(pathTo.login);
      }

      render() {
        return (
          <Container>
            <Topbar hasSearch={config.search} />
            <Main>
              <Component {...this.props} />
            </Main>
            <Drawer />
          </Container>
        );
      }
    }
  );



// WEBPACK FOOTER //
// ./src/assist/withTopbar.js